import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TypedDialog } from '@app-types/Dialog';
import { DialogContainerComponent } from '@ui-components/dialog/dialog-container/dialog-container.component';
import { StButtonComponent } from '@ui-components/st-button/st-button.component';

@Component({
  template: `
    <app-dialog-container
      testId="app-error.scope.chunk-dialog"
      [state]="state"
      [disableClose]="true"
      [backdropClose]="false"
      classNames="extra-small compact-mobile"
      padding="40px">
      <div class="flex flex-col items-center justify-center gap-5 text-center">
        <h2
          class="st-h2"
          data-testid="app-error.status.chunk-failed"
          >Something went wrong</h2
        >

        <p class="text-body">
          We couldn't load this part of the app. Please refresh the page to try again.
        </p>

        <button
          st-button
          variant="dark"
          full
          (click)="reloadPage()"
          data-testid="app-error.action.reload">
          Refresh page
        </button>
      </div>
    </app-dialog-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogContainerComponent, StButtonComponent],
})
export class ChunkLoadErrorModalComponent extends TypedDialog<void> {
  reloadPage(): void {
    globalThis.location.reload();
  }
}
